const PLUGIN_NAME = 'list-query-variables-plugin';
const FILTER_PROPERTIES = [
  'name',
  'metaTitle',
  'metaDescription',
  'summary',
  'authorName',
  'tags.name',
  'category.name',
  'publishedCompanies.name',
  'companyTags.name',
  'profileTags.name',
  'publishedProfiles.name',
  'pageBuilderIndexed'
];
const SMALL_BOOST_PROPERTIES = ['publishedCompanies.name', 'companyTags.name'];
const BIG_BOOST_PROPERTIES = ['name'];
const BOOST_SCORES = {
  SMALL: 5,
  BIG: 10
};

const MUST_FILTERS = [
  {
    bool: {
      should: [
        {
          bool: {
            should: [
              {
                match: {
                  'articleType.name.keyword': 'Features'
                }
              },
              {
                match: {
                  'articleType.name.keyword': 'News'
                }
              }
            ]
          }
        }
      ]
    }
  }
];

export {
  PLUGIN_NAME,
  MUST_FILTERS,
  FILTER_PROPERTIES,
  SMALL_BOOST_PROPERTIES,
  BIG_BOOST_PROPERTIES,
  BOOST_SCORES
};
